import { render } from "./WCCartDrawerItemPricing.vue?vue&type=template&id=b9991544&scoped=true"
import script from "./WCCartDrawerItemPricing.vue?vue&type=script&lang=js"
export * from "./WCCartDrawerItemPricing.vue?vue&type=script&lang=js"

import "./WCCartDrawerItemPricing.vue?vue&type=style&index=0&id=b9991544&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9991544"]])

export default __exports__